package com.example.monetix.ui.components

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Switch
import androidx.compose.material3.SwitchDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color

/**
 * 🚀 SWITCH GLASSMORPHISM UNIVERSALE MONETIX
 * Quando disabilitato (checked = false):
 *  - Traccia in vetro traslucido scuro satinato
 *  - Bordo in vetro chiaro luminoso
 *  - Pallino (Thumb) in bianco satinato morbido
 *
 * Quando abilitato (checked = true):
 *  - Traccia nel tono del colore primario della schermata/tema (activeColor)
 *  - Pallino (Thumb) in Bianco Puro brillante
 */
@Composable
fun MonetixGlassSwitch(
    checked: Boolean,
    onCheckedChange: ((Boolean) -> Unit)?,
    modifier: Modifier = Modifier,
    activeColor: Color = MaterialTheme.colorScheme.primary,
    enabled: Boolean = true
) {
    Switch(
        checked = checked,
        onCheckedChange = onCheckedChange,
        modifier = modifier,
        enabled = enabled,
        colors = SwitchDefaults.colors(
            checkedThumbColor = Color.White,
            checkedTrackColor = activeColor,
            checkedBorderColor = activeColor.copy(alpha = 0.80f),
            checkedIconColor = Color.Transparent,
            uncheckedThumbColor = Color.White.copy(alpha = 0.85f),
            uncheckedTrackColor = Color.Black.copy(alpha = 0.30f),
            uncheckedBorderColor = Color.White.copy(alpha = 0.25f),
            uncheckedIconColor = Color.Transparent
        )
    )
}
